import React from 'react';
import { useInactivityTimer } from '@/hooks/useInactivityTimer';

/**
 * Wrapper component that enables inactivity timer for authenticated users
 */
const InactivityWrapper = ({ children, onLogout, enabled = true }) => {
  // Enable inactivity timer (15 minutes as per user requirement)
  if (enabled) {
    useInactivityTimer(15, onLogout);
  }
  
  return <>{children}</>;
};

export default InactivityWrapper;
